/* eslint-disable @typescript-eslint/ban-ts-comment */

/* eslint-disable react/prop-types */
import { useQuery } from "@apollo/client";

import categoryCountsQuery from "web/queries/ms/categoryCounts.graphql";

import type { ICategoryCount } from "web/types/CategoryCount";

const useCategoryCount = (token: string, storeId: number, ids?: number[]) => {
  const { data, error, loading } = useQuery<{
    msCategoryCounts: { edges: { node: ICategoryCount }[] };
  }>(categoryCountsQuery, {
    variables: {
      ids,
      token,
      storeId,
    },
    context: {
      clientName: "ms",
    },
    fetchPolicy: "cache-and-network",
    skip: !ids,
  });

  if (!ids) {
    return {};
  }

  const transformedData = data?.msCategoryCounts?.edges;
  return { data: transformedData, error, loading };
};

export default useCategoryCount;
